import { useState } from 'react';
import { Button } from '../../../../core/components/atoms/Button';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Modal } from '../../../../core/components/templates/Modal';
import InnerCheckbox from '../../../Disciplines/components/exercises/components/innerCheckbox';
import { searchFilterStore } from '../../stores/searchFilters';
import './styles.css';

interface IModalFilter {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const disciplines = [
  { value: 'biologia', label: 'Biologia' },
  { value: 'fisica', label: 'Física' },
  { value: 'quimica', label: 'Química' },
  { value: 'matematica', label: 'Matemática' },
  { value: 'historia', label: 'História' },
  { value: 'geografia', label: 'Geografia' },
  { value: 'atualidades', label: 'Atualidades' },
  { value: 'filosofia', label: 'Filosofia' },
  { value: 'portugues', label: 'Português' },
  { value: 'literatura', label: 'Literatura' },
  { value: 'ingles', label: 'Inglês' },
  { value: 'espanhol', label: 'Espanhol' },
  { value: 'interdisciplinar', label: 'Interdisciplinar' },
  { value: 'redacao', label: 'Redação' },
  { value: 'sociologia', label: 'Sociologia' },
];

export default function FilterSearch({
  isOpen,
  onClose,
  onSubmit,
}: IModalFilter) {
  const {
    categorySearch,
    disciplineSearch,
    addDisciplineSearch,
    removeDisciplineSearch,
    resetFilterSearch,
    setCategorySearch,
    setDisciplineSearch,
  } = searchFilterStore();

  const [isClean, setIsClean] = useState<boolean>(false);
  const [categoryAux, setCategoryAux] = useState<string[]>([]);
  const [disciplineAux, setDisciplineAux] = useState<string[]>([]);

  const handleDiscipline = (disciplina: string) => {
    if (isClean) {
      setIsClean(false);
    }

    if (disciplineSearch.includes(disciplina)) {
      removeDisciplineSearch(disciplina);
    } else {
      addDisciplineSearch(disciplina);
    }
  };

  const reset = () => {
    setIsClean(true);
    setCategoryAux(categorySearch);
    setDisciplineAux(disciplineSearch);
    resetFilterSearch();
  };

  const handleSubmit = () => {
    if (isClean) {
      setIsClean(false);
      resetFilterSearch();
      onSubmit();
    } else {
      setCategoryAux([]);
      setDisciplineAux([]);
      onSubmit();
    }
  };

  const abbandon = () => {
    if (isClean) {
      setCategorySearch(categoryAux);
      setDisciplineSearch(disciplineAux);
      setIsClean(false);
    }

    onClose();
  };

  return (
    <Modal
      position={window.innerWidth < 768 ? 'bottom' : 'top-right'}
      size='md'
      isOpen={isOpen}
      onClose={() => abbandon()}
      className='xs:h-[90vh] xs:w-full sm:h-[75vh] md:h-[95vh] md:w-[35%]'
      title='Filtrar temas'
    >
      <div
        id='filterContainer'
        className='flex w-full flex-col gap-md overflow-y-auto px-2 pb-24 pt-2 xs:h-[58vh] sm:h-[48vh] md:h-[75vh]'
      >
        <Typography size='h4' type='title' className='text-left'>
          Disciplinas
        </Typography>
        <div className='flex w-full flex-col gap-xl pl-4'>
          {disciplines.map((d) => (
            <InnerCheckbox
              key={d.value}
              onChange={() => handleDiscipline(d.value)}
              label={d.label}
              checked={disciplineSearch.includes(d.value)}
              id={`disciplines-${d.value}`}
              value={d.value}
            />
          ))}
        </div>
      </div>
      <div className='fixed bottom-0 left-0 flex w-full flex-col items-center justify-center gap-lg bg-card-color-default py-5 dark:bg-color-lighter'>
        <div className='w-full border-b-hairline border-mono-color-light' />
        <div className='flex w-full flex-row gap-lg px-4'>
          <Button
            variant='text'
            className='w-1/2 xs:text-sm md:text-md'
            full
            onClick={() => reset()}
          >
            <Icon Icon='delete' type='material' className='text-sm' />
            Limpar seleção
          </Button>
          <Button
            className='w-1/2 xs:text-sm md:text-md'
            full
            onClick={() => handleSubmit()}
          >
            Aplicar filtros
          </Button>
        </div>
      </div>
    </Modal>
  );
}
